import GlassCard from "Developers/JuanBecchio/Components/GlassCard";

const MusicaRockMetal = (): JSX.Element => {
  return (
    <div>
      <h5 className='mt-4 text-center subtitle-inner-section'>Rock/Metal</h5>
      <div className='devprofile-extra-inner'>
        <GlassCard
          title='Una de mis canciones favoritas'
          tooltip='Killswitch Engage - My Curse'>
          <iframe
            className='compact-m'
            title='Killswitch'
            src='https://open.spotify.com/embed/track/6zKF4293k44ItKWJJgrhXv'
            allow='encrypted-media'
          />
        </GlassCard>
        <GlassCard
          title='Algunas de mis bandas favoritas'
          tooltip='Linkin Park | Spiritbox'
          disableParallax>
          <div>
            <iframe
              title='LinkinPark'
              src='https://open.spotify.com/embed/artist/6XyY86QOPPrYVGvF9ch6wz'
              allow='encrypted-media'
            />
            <iframe
              title='Spiritbox'
              src='https://open.spotify.com/embed/artist/4MzJMcHQBl9SIYSjwWn8QW'
              allow='encrypted-media'
            />
          </div>
        </GlassCard>
      </div>
    </div>
  );
};

export default MusicaRockMetal;
